/** Product access switches. */
export const workspaceAccessConfig: {
  requireLoginToGenerate: boolean;
  paidEntitlementsEnabled: boolean;
  /** Toggle guest one-time checkout without changing account purchases. */
  guestOneTimeTaskPaymentEnabled: boolean;
} = {
  requireLoginToGenerate: true,
  paidEntitlementsEnabled: true,
  guestOneTimeTaskPaymentEnabled: false,
};
